export function sumReducer(left: number, right: number): number {
    return left + right;
}